<template>
  <div class="main">
    <div class="title">报名条件</div>

    <div class="content">

      <div class="sj">凡符合下述条件的上海市市民或常住上海的外省市公民，在征得家人同意后，可报名参加造血干细胞捐献。</div>

      <div class="sj mt20">1、年龄在18～45周岁；</div>
      <div class="sj mt10">2、男性体重＞50公斤，女性体重＞45公斤，身体健康，符合献血条件；</div>

      <div class="sj mt10">3、上海市市民或常住在上海的外省市公民已征求家人（父母、配偶或其他直系亲属）意见；</div>

      <div class="sj mt20">如有以下情况则不能报名参加造血干细胞捐献：</div>

      <div class="sj mt10">1、性病、艾滋病患者及艾滋病病毒感染者；</div>
      <div class="sj mt10">2、乙肝、丙肝患者以及乙肝丙肝病毒携带者；</div>
      <div class="sj mt10">3、过敏性疾病及反复发作过敏者；</div>
      <div class="sj mt10">4、各种结核病患者以及自身患有免疫性疾病（如红斑狼疮、硬皮病等）；</div>
      <div class="sj mt10">5、心血管疾病患者、如各种心脏病、高血压、心肌炎等；</div>
      <div class="sj mt10">6、严重呼吸系统疾病及消化系统疾病；</div>
      <div class="sj mt10">7、血液病患者，如白血病、重症贫血等；</div>
      <div class="sj mt10">8、做过重要器官切除手术者以及眼底有病变的高度近视者（800度以上）；</div>
      <div class="sj mt10">9、患有恶性肿瘤以及影响健康的良性肿瘤；</div>
      <div class="sj mt10">10、精神病患者以及内分泌疾病患者。</div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  // height: 690px;
  font-size: 14px;
  min-height: 100vh;
  background-image: url("../../assets/cjd/bg.png");
  background-size: cover;

  .title {
    margin-top: 120px;
    font-size: 26px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;
    padding: 25px;
    // height: 800px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>